
const newModel = () => {
    return {
        nhaHangId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        tenPhuongXa: null,
        phuongXaId: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        web: null,
        gioiThieu: null,
        gioMoCua: null,
        ghiChu: null,
        stt: null,
        fListHinhAnh: null, //PostValue
        fileHinhAnhInfo: [], //GetValue
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null

    }
}

const newFEModel = () => {
    return {
        nhaHangId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        tenPhuongXa: null,
        phuongXaId: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        web: null,
        gioiThieu: null,
        gioMoCua: null,
        ghiChu: null,
        stt: "0",
        fListHinhAnh: null, //PostValue
        fileHinhAnhInfo: [], //GetValue
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        nhaHangId: item.nhaHangId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        tenPhuongXa: item.tenPhuongXa,
        phuongXaId: item.phuongXaId,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        web: item.web,
        gioiThieu: item.gioiThieu,
        gioMoCua: item.gioMoCua,
        ghiChu: item.ghiChu,
        stt: item.stt,
        fListHinhAnh: item.fListHinhAnh,
        fileHinhAnhInfo: item.fileHinhAnhInfo,
        xoaListHinhAnh: item.xoaListHinhAnh,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        nhaHangId: item.nhaHangId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        phuongXaId: item.phuongXaId,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        web: item.web,
        gioiThieu: item.gioiThieu,
        gioMoCua: item.gioMoCua,
        ghiChu: item.ghiChu,
        stt: item.stt,
        fListHinhAnh: item.fListHinhAnh,
        fileHinhAnhInfo: item.fileHinhAnhInfo,
        xoaListHinhAnh: item.xoaListHinhAnh,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        phuongXaId: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        ten: item.ten,
        phuongXaId: item.phuongXaId,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        nhaHangId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        tenPhuongXa: null,
        phuongXaId: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        web: null,
        gioiThieu: null,
        gioMoCua: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
    }
}

export const nhaHangModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


